import { render, staticRenderFns } from "./gsmotp.vue?vue&type=template&id=30a858ba&scoped=true"
import script from "./gsmotp.vue?vue&type=script&lang=js"
export * from "./gsmotp.vue?vue&type=script&lang=js"
import style0 from "./gsmotp.vue?vue&type=style&index=0&id=30a858ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a858ba",
  null
  
)

export default component.exports